<div class="panel panel-success widget-support-tickets">
  <div class="panel-heading">
    <span class="panel-title">{{'orgJobStr.organizationJobsStructureTargets' | translate}} {{targetType}}</span>
  </div>
  <div class="panel-body padding-sm-hr">
    <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">
      <div class="row">
        <div class="col-sm-9">
        </div>
        <div class="col-sm-3 margin-top-10 left-10 cursor-pointer" (click)="addNew()">
          <span class="margin-right-7 create-new-span">{{'app.CreateNew' | translate}}</span>
          <i class="fa fa-plus-circle"></i>
        </div>

      </div>
      <div class="row">
        <div class="col-sm-12">

          <p-table [value]="orgJobStrTargetDates" [responsive]="true">
            <ng-template pTemplate="header">
              <tr>
                <th class="table-edit">
                  {{'orgJobStr.target' | translate}}
                </th>
                <th class="table-edit">
                  {{'orgJobStr.startDate' | translate}}
                </th>
                <th class="table-edit">{{'orgJobStr.endDate' | translate}}</th>
                <th class="table-edit"> {{'orgJobStr.isCurrent' | translate}}</th>
                <th width="10%" style="text-align:center" class="table-edit">{{'app.edit' | translate}}</th>
                <th width="10%" style="text-align:center" class="table-edit">{{'app.delete' | translate}}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-target>
              <tr *ngIf="orgJobStrTargetDates.length>0 && displayMode===2">
                <td>
                  {{target.target}}
                </td>
                <td>{{target.startDate |date :'dd-MM-yyy'}}</td>
                <td>{{target.endDate |date :'dd-MM-yyy'}}</td>
                <td>
                  <span *ngIf="target.isCurrent" class="fa fa-2x fa-check-circle"></span>
                  <span *ngIf="!target.isCurrent" class="fa fa-2x fa-times-circle"></span>
                </td>
                <td>
                  <a class="" href="javascript:;" (click)="edit(target)"><i class="fa fa-edit fa-lg font-size-20"></i></a>
                </td>
                <td><a href="javascript:;" (click)="confirmDelete(target.id)"><i class="fa fa-trash-o  fa-lg font-size-20"></i></a></td>
              </tr>
              <tr *ngIf="orgJobStrTargetDates.length===0 && displayMode===2">
                <td colspan="5">{{'app.NoDataFound' | translate}}</td>
              </tr>
              <tr *ngIf="displayMode==1">
                <td colspan="5">
                  <div class="row col-sm-12 padding-sm-hr">
                    <div class="container text-center">
                      <i class="fa fa-spinner fa-spin" style="font-size:48px;color:darkseagreen"></i> <p>{{'app.Loading' | translate}}</p>
                    </div>

                  </div>

                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
      <div class="panel-footer margin-left-20 margin-top-20 margin-left-37">
        <button class="btn  btn-cancel" type="button" (click)="back()">{{'app.cancel' | translate}}</button>&nbsp;

      </div>
    </div>
  </div>
</div>

<div class="row" *ngIf="displayMode==3">
  <div class="col-sm-12">
    <div class="alert alert-danger alert-dark">
      <button type="button" class="close" data-dismiss="alert">×</button>
      {{'app.ServerError' |translate}}.
    </div>
  </div>
</div>


<div class="modal fade" bsModal #deleteOrgJobStrTargetDatesModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1">
  <div class="modal-dialog modal-lg">
    <div class="panel padding-2">
      <div>
        <h1 class="delete-title">{{'app.deleteMsgConfirmation' | translate}}</h1>
      </div>
      <div class="row panel-body padding-sm-hr padding-top-0 padding-bottom-0">

        <div class="panel-footer margin-left-20 margin-top-20">
          <button type="button" (click)="hideDeleteModal()" class="btn btn-cancel">{{'app.cancel' | translate}}</button>
          <button type="button" class="btn btn-save" (click)="deleteOrganizationJobStructureTargetDates()">{{'app.delete' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="modal-sizes-1" bsModal #orgJobStrTargetDatesModal="bs-modal" (onHidden)="onEditorModalHidden()" [config]="{backdrop: 'static'}" tabindex="-1">
  <div class="modal-dialog  modal-lg">
    <div class="panel padding-2">
      <div>
        <h1 class="filter-title pull-left width-90">{{'orgJobStr.target' | translate}}</h1>
        <button type="button" class="close pull-right" title="Close" (click)="orgJobStrTargetDatesModal.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <crm-save-org-job-str-target-dates #orgJobStrTargettDatesEditor></crm-save-org-job-str-target-dates>
    </div>
  </div>
</div>
